import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { FirebaseRemoteConfigService } from "@core/services/firebaseremoteconfig.service";
import { PeriodDTO } from "@shared/models/period-dto";
import moment from "moment";
import { KeycloakService } from "keycloak-angular";
import { KeycloakHelperService } from "@core/services";

@Component({
    selector: "app-driveb-select-date-period-available-carworkshop",
    templateUrl: "./select-date-period-available-carworkshop.component.html",
    styleUrls: ["./select-date-period-available-carworkshop.component.scss"],
    standalone: false
})
export class SelectDatePeriodAvailableCarworkshopComponent implements OnInit {
  @Input() isBackofficeUserLogged = false;
  @Input() daysAdvanceForAppointments;
  @Input() periods: PeriodDTO[] = [];
  @Input() set setUnavailableDatesPeriods(value: any) {
    this.unavailableDatesPeriods = value;
    this.filterDatePickerSchedule();
  }
  @Input() title: string;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  filterDatePicker = (date): boolean => {
    return true;
  };

  carworkshopMinimumDateAvailableDate;
  unavailableDatesPeriods = [];
  unavailableDates = [];

  form = this.fb.group({
    date: [new Date(new Date().setHours(0, 0, 0, 0))],
    period: [""]
  });

  constructor(
    private fb: UntypedFormBuilder,
    private remoteConfigService: FirebaseRemoteConfigService,
    private keycloakHelperService: KeycloakHelperService
  ) {}

  isFleetAdmin =
    this.keycloakHelperService.isFleetAdminNonApproverLogged() ||
    this.keycloakHelperService.isFleetAdminApproverLogged() ||
    this.keycloakHelperService.isFleetAdminLogged() ||
    this.keycloakHelperService.isFleetAdminLogged() ||
    this.keycloakHelperService.isDriverApproverLogged() ||
    this.keycloakHelperService.isDriverLogged();

  ngOnInit() {}

  async updateFormDate(value: any) {
    const holidays = await this.remoteConfigService.getRemoteConfigValue(
      "holidays"
    );

    this.periods.forEach((element) => {
      element.disabled = false;
    });

    this.form.get("period").setValue(null);
    this.form.get("date").setValue(value);
    this.changePeriod();
    const dateFormatted = moment(value).format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    const tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
    const isAfternoonNow = moment().hour() > 12;
    if (dateFormatted === today && this.isFleetAdmin) {
      this.periods.forEach((period) => {
        period.disabled = true;
      });
    }

    if (dateFormatted === tomorrow && isAfternoonNow && this.isFleetAdmin) {
      this.periods.forEach((period) => {
        if (period.value == "MORNING") {
          period.disabled = true;
        }
      });
    }
    const rightFormat = moment(value).format("DD/MM/YYYY");
    const isHoliday = holidays
      .split("; ")
      .map((date) => date.trim())
      .includes(rightFormat);
    if (isHoliday) {
      this.periods.forEach((period) => {
        period.disabled = true;
      });
    }

    this.unavailableDatesPeriods.forEach((element) => {
      if (element.date == dateFormatted) {
        const selectedPeriod = this.periods.find(
          (period) => period.value == element.period
        );
        selectedPeriod.disabled = true;
      }
    });
  }

  async disabledUnvaliableDates() {
    this.filterDatePicker = (date): boolean => {
      const dateFormatted = moment(date).format("YYYY-MM-DD");
      const day = date.day();
      const onlyDates = this.unavailableDatesPeriods.map((item) => item.date);
      this.unavailableDates = onlyDates.filter(function (item, idx) {
        return onlyDates.indexOf(item) != idx;
      });

      return (
        day !== 0 &&
        day !== 6 &&
        !this.unavailableDates.find((x) => x == dateFormatted)
      );
    };
  }

  async filterDatePickerSchedule() {
    await this.disabledUnvaliableDates();
    const todayDate = new Date(new Date().setHours(0, 0, 0, 0));
    if (this.isBackofficeUserLogged) {
      this.carworkshopMinimumDateAvailableDate = todayDate;
    } else {
      this.carworkshopMinimumDateAvailableDate = moment(todayDate).add(
        this.daysAdvanceForAppointments,
        "day"
      );

      if (
        (todayDate.getDay() == 5 && this.daysAdvanceForAppointments == 3) ||
        this.carworkshopMinimumDateAvailableDate.day() == 0 ||
        this.carworkshopMinimumDateAvailableDate.day() == 6
      ) {
        this.carworkshopMinimumDateAvailableDate = moment(
          this.carworkshopMinimumDateAvailableDate
        ).add(2, "day");
      }

      while (
        this.unavailableDates.find(
          (x) =>
            x ==
            moment(this.carworkshopMinimumDateAvailableDate).format(
              "YYYY-MM-DD"
            )
        ) ||
        this.carworkshopMinimumDateAvailableDate.day() == 0 ||
        this.carworkshopMinimumDateAvailableDate.day() == 6
      ) {
        this.carworkshopMinimumDateAvailableDate = moment(
          this.carworkshopMinimumDateAvailableDate
        ).add(1, "day");
      }
    }

    this.form.get("date").setValue(this.carworkshopMinimumDateAvailableDate);
    this.updateFormDate(this.form.get("date").value);
  }

  changePeriod() {
    setTimeout(() => {
      this.onChange.emit({
        date: this.form.get("date").value.toISOString(),
        period: this.form.get("period").value
      });
    }, 0);
  }
}
